import {
  SHOW_TURNTABLE,
  SET_TURNTABLE_SIZE,
  SET_RESULT_SELECTED,
  SET_CHOICES,
  SET_MODE,
  SET_HISTORY,
  SET_RESULTS_ARRAY,
  SET_BOARD_INDEX,
  SET_TYPE_OPTION,
  SET_AUTO_SPIN_MERGE,
  SET_MIN_VALUE,
  SET_MAX_VALUE,
  SET_INTERVAL_VALUE,
  SET_TITLE_OBJ,
  SET_EXCLUDE_FIELD_VALUE,
  SET_FORMULA_FIELD_VALUE,
  SET_INPUT_METHOD,
  SET_DIGIT_RANGES,
  SET_DIGIT_NUMBER,
  SET_MYSTERY_WHEEL_ON,
  SET_MYSTERY_RESULT_ON,
  UPDATE_MYSTERY_SETTINGS,
  SET_SCORES,
  SET_AUTO_ADD_COUNT,
} from './constants'
import { setStartRotate } from '../turntable/actions'
import { setDataStatus } from '../common/actions'

export const showTurntable = turntable => ({
  type: SHOW_TURNTABLE,
  payload: {
    turntable,
  },
})

export const setTurntableSize = size => ({
  type: SET_TURNTABLE_SIZE,
  payload: {
    size,
  },
})

export const setResultSelected = (result, resultPieColor = null) => ({
  type: SET_RESULT_SELECTED,
  payload: {
    result,
    resultPieColor,
  },
})

export const setHistory = history => ({
  type: SET_HISTORY,
  payload: {
    history,
  },
})

export const setChoices =
  (choices, resetAngle = true) =>
  async (dispatch, getState) => {
    if (resetAngle) {
      const state = getState()
      const startAngle = state.settings.spinBehavior.randomStart
        ? 2 * Math.PI * Math.random()
        : 0
      dispatch(setStartRotate(startAngle))
    }
    dispatch({
      type: SET_CHOICES,
      payload: {
        choices,
      },
    })
  }

export const setMode = mode => ({
  type: SET_MODE,
  payload: {
    mode,
  },
})

export const setResultsArray = results => {
  return {
    type: SET_RESULTS_ARRAY,
    payload: {
      results,
    },
  }
}

export const setBoardIndex = index => {
  return {
    type: SET_BOARD_INDEX,
    payload: {
      index,
    },
  }
}

export const setTypeOption = option => dispatch => {
  dispatch({
    type: SET_TYPE_OPTION,
    payload: {
      option,
    },
  })
  dispatch(setDataStatus('Modified', 'Inputs'))
}

export const setAutoSpinMerge = status => dispatch => {
  dispatch({
    type: SET_AUTO_SPIN_MERGE,
    payload: {
      status,
    },
  })
  dispatch(setDataStatus('Modified', 'Inputs'))
}

export const setMinValueStore = min => dispatch => {
  dispatch({
    type: SET_MIN_VALUE,
    payload: {
      min,
    },
  })
  dispatch(setDataStatus('Modified', 'Inputs'))
}

export const setMaxValueStore = max => dispatch => {
  dispatch({
    type: SET_MAX_VALUE,
    payload: {
      max,
    },
  })
  dispatch(setDataStatus('Modified', 'Inputs'))
}

export const setIntervalValueStore = interval => dispatch => {
  dispatch({
    type: SET_INTERVAL_VALUE,
    payload: {
      interval,
    },
  })
  dispatch(setDataStatus('Modified', 'Inputs'))
}

//03-07-2021 add title
export const setTitleActive = active => dispatch => {
  dispatch(setTitleObj({ active }))
}

export const setTitleText = text => dispatch => {
  dispatch(setTitleObj({ text }))
}

export const setTitleObj = obj => dispatch => {
  dispatch({
    type: SET_TITLE_OBJ,
    payload: {
      obj,
    },
  })
  dispatch(setDataStatus('Modified', 'Title & Desc.'))
}

export const setExcludeFieldValue = value => dispatch => {
  dispatch({
    type: SET_EXCLUDE_FIELD_VALUE,
    payload: {
      value,
    },
  })
  dispatch(setDataStatus('Modified', 'Inputs'))
}

export const setFormulaFieldValue =
  (value, nullTurntable = false) =>
  dispatch => {
    dispatch({
      type: SET_FORMULA_FIELD_VALUE,
      payload: {
        value,
      },
    })
    dispatch(setDataStatus('Modified', 'Inputs'))
    if (nullTurntable) dispatch(showTurntable(null))
  }

export const setInputMethod = method => dispatch => {
  dispatch({
    type: SET_INPUT_METHOD,
    payload: {
      method,
    },
  })
  dispatch(setDataStatus('Modified', 'Inputs'))
}

export const setDigitRanges = ranges => dispatch => {
  dispatch({
    type: SET_DIGIT_RANGES,
    payload: {
      ranges,
    },
  })
  dispatch(setDataStatus('Modified', 'Inputs'))
}

export const setDigitNumber = number => dispatch => {
  dispatch({
    type: SET_DIGIT_NUMBER,
    payload: {
      number,
    },
  })
  dispatch(setDataStatus('Modified', 'Inputs'))
}

export const setMysteryWheelOn = status => dispatch => {
  dispatch({
    type: SET_MYSTERY_WHEEL_ON,
    payload: {
      status,
    },
  })
  dispatch(setDataStatus('Modified', 'Mystery'))
}

export const setMysteryResultOn = status => dispatch => {
  dispatch({
    type: SET_MYSTERY_RESULT_ON,
    payload: {
      status,
    },
  })
  dispatch(setDataStatus('Modified', 'Mystery'))
}

export const updateMysterySettings =
  (mysteryWheelOn, mysteryResultOn) => async (dispatch, getState) => {
    try {
      const state = getState()
      const pastMysteryWheelOn = state.rng.mysteryWheelOn
      dispatch({
        type: UPDATE_MYSTERY_SETTINGS,
        payload: {
          mysteryWheelOn,
          mysteryResultOn,
        },
      })
      // redraw wheel
      if (pastMysteryWheelOn !== mysteryWheelOn) {
        dispatch(showTurntable(null))
      }
      dispatch(setDataStatus('Unchanged')) //load from sharewheel and load list
    } catch (error) {
      console.log(error)
    }
  }

export const setScores =
  (scores, dataStatus = 'Modified') =>
  dispatch => {
    dispatch({
      type: SET_SCORES,
      payload: {
        scores,
      },
    })
    dispatch(setDataStatus(dataStatus, 'Scores'))
  }

export const setAutoAddCount = status => ({
  type: SET_AUTO_ADD_COUNT,
  payload: {
    status,
  },
})
